/**
 * Pre-compiled de messages for DefaultPage
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { backLink: `Zurück` };
